import { render, staticRenderFns } from "./DropdownPagination.vue?vue&type=template&id=28b7e796&"
import script from "./DropdownPagination.vue?vue&type=script&lang=ts&"
export * from "./DropdownPagination.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports